exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-wrapper select[data-v-a2829b3c] {\n  border-radius: 0;\n  padding-right: 53px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  -webkit-border-radius: 0;\n  cursor: pointer;\n}\n.has-error[data-v-a2829b3c] {\n  border-bottom-width: 2px;\n  border-bottom-color: #e81212;\n}\n.icon[data-v-a2829b3c] {\n  right: 22px;\n}\n", ""]);

// exports
